import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=fc5b0a56&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./BottomNavigation.vue?vue&type=style&index=0&id=fc5b0a56&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./BottomNavigation.vue?vue&type=style&index=1&id=fc5b0a56&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fc5b0a56",
  "71f53dd0"
  
)

export default component.exports